import { render } from "./moderation_tools.vue?vue&type=template&id=b757dee6"
import script from "./moderation_tools.js?vue&type=script&lang=js&external"
export * from "./moderation_tools.js?vue&type=script&lang=js&external"

import "./moderation_tools.vue?vue&type=style&index=0&id=b757dee6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__